// extracted by mini-css-extract-plugin
export default {"acknowledgementsContainer":"ExpertGroupsForApp_acknowledgementsContainer__Heoum","acknowledgementsContent":"ExpertGroupsForApp_acknowledgementsContent__J2YOD"};